export default "__VITE_ASSET__Bb05Ba65__"